import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AdminProvider } from './contexts/AdminContext';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import BandeauAdmin from './components/bandeauAdmin/bandeauAdmin';

const Accueil        = lazy(() => import('./pages/accueil/accueil'));
const About          = lazy(() => import('./pages/about/about'));
const Contact        = lazy(() => import('./pages/contact/contact'));
const Histoire       = lazy(() => import('./pages/histoire/histoire'));
const Houblon        = lazy(() => import('./pages/houblon/houblon'));
const Mouton         = lazy(() => import('./pages/mouton/mouton'));
const Produit        = lazy(() => import('./pages/mouton/produit'));
const Visite         = lazy(() => import('./pages/visite/visite'));
const NosValeurs     = lazy(() => import('./pages/valeurs/valeurs'));
const Mentions       = lazy(() => import('./pages/mentions/mentions'));
const NotFound       = lazy(() => import('./pages/notFound/notFound'));
const AdminLogin     = lazy(() => import('./pages/admin/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));

function App() {
  return (
    <AdminProvider>
      <Router>
        <div>
          <BandeauAdmin />
          <Header />
          <main className="app-main">
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<Accueil />} />
                <Route path="/nos-valeurs" element={<NosValeurs />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/histoire" element={<Histoire />} />
                <Route path="/houblon" element={<Houblon />} />
                <Route path="/mouton" element={<Mouton />} />
                <Route path="/produit" element={<Produit />} />
                <Route path="/visite" element={<Visite />} />
                <Route path="/mentions" element={<Mentions />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </AdminProvider>
  );
}

export default App;
